import { fileManagementApi } from "features/data-management/files/fileManagementApi"

export async function uploadMapSnapshotToS3(blob: Blob, organizationId: string, projectId: string) {
    const key = `public/org/${organizationId}/project/${projectId}/uploadMapSnapshot`

    await fileManagementApi.putFile(blob, { target: key })

    const url = await fileManagementApi.getDownloadUrl(key)
    return `${url}?v=${Date.now()}`
}
